import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Stack,
  TypographyProps,
  useTheme,
  useMediaQuery,
  Divider,
} from '@mui/material';
import { TP_COLORS } from '../../../constants';

const titleTypoProps: TypographyProps['sx'] = {
  component: 'p',
  fontSize: '18px',
  fontWeight: 600,
  color: '#1E293B',
  textAlign: 'center',
  fontFamily: 'inherit',
};

const bodyTypoProps: TypographyProps['sx'] = {
  component: 'p',
  fontSize: '16px',
  fontWeight: 400,
  color: '#1E293B',
  textAlign: 'center',
  fontFamily: 'inherit',
  marginBottom: '10px',
};

const steps = [
  {
    icon: '🔍',
    title: 'Self Assessment',
    description: 'Do a diagnostics to analyze yourself',
    step: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/1.png`,
  },
  {
    icon: '💪🏻',
    title: 'Strength & Gaps',
    description: 'Check your areas of strength and weak points ',
    step: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/2.png`,
  },
  {
    icon: '📚',
    title: 'Interactive Learning',
    description: 'Start learning with resources and practice questions',
    step: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/3.png`,
  },
  {
    icon: '🧠',
    title: 'AI-Powered Quiz',
    description: 'Build confidence with AI-powered Quiz',
    step: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/4.png`,
  },
  {
    icon: '🚀',
    title: 'Track Progress',
    description: 'Re-do the diagnostic to check progress',
    step: `${process.env.PUBLIC_URL}/images/landingPage/newLandingPage/5.png`,
  },
];

const FeaturesSection: React.FC = () => {
  const theme = useTheme();
  const belowMd = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ py: 6, px: 3, position: 'relative' }}>
      <Box
        sx={{
          position: 'absolute',
          bottom: { xs: 'auto', md: '30%' },
          left: '10%',
          right: '10%',
          height: '2px',
          borderBottom: !belowMd ? '2px dotted #d3d3d3' : 'none',
          zIndex: 0,
        }}
      />

      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{ position: 'relative', zIndex: 1 }}
      >
        {steps.map((stepItem) => (
          <Box
            sx={{
              display: { xs: 'block', md: 'flex' },
              justifyContent: 'center',
              alignItems: 'stretch',
              gap: 4,
              position: 'relative',
              zIndex: 1,
            }}
          >
            <Paper
              elevation={0}
              sx={{
                textAlign: 'center',
                backgroundColor: 'transparent',
                width: '240px',
                p: '8px',
              }}
            >
              <Box sx={{ fontSize: '35px' }} mb={!belowMd ? 4 : 1}>
                {stepItem.icon}
              </Box>
              <Typography variant="h6" mb={1} sx={titleTypoProps} gutterBottom>
                {stepItem.title}
              </Typography>
              <Typography variant="body1" sx={bodyTypoProps}>
                {stepItem.description}
              </Typography>
              <Box mt={3} mb={!belowMd ? 1 : 4}>
                <Stack
                  direction="column"
                  justifyContent="center"
                  alignItems="center"
                  spacing={1}
                >
                  <img
                    src={stepItem.step}
                    alt={stepItem.title}
                    style={{ width: '35px', height: '45px' }}
                  />
                  <Typography variant="subtitle2" fontWeight="bold">
                    STEP
                  </Typography>
                  {belowMd && (
                    <Divider
                      flexItem
                      sx={{
                        borderStyle: 'dashed',
                        borderColor: TP_COLORS.border.color2,
                      }}
                    />
                  )}
                </Stack>
              </Box>
            </Paper>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

export default FeaturesSection;
